const DESTINATION_PARAM = "cc";
const VIEW_PARAM = "cc_view";
const DEFAULT_DESTINATION = "command";
const DEFAULT_VIEW = "overview";
const SAFE_SEGMENT = /^[a-z0-9][a-z0-9_-]{0,63}$/;

export const COMMAND_CENTER_DESTINATIONS = Object.freeze([
  "command",
  "operations",
  "library",
  "connections",
  "insights",
  "account",
]);

function asUrl(locationLike) {
  if (locationLike instanceof URL) return new URL(locationLike.toString());
  if (typeof locationLike === "string") {
    return new URL(locationLike, "https://optimus.local");
  }
  const href = locationLike?.href ||
    `${locationLike?.pathname || "/"}${locationLike?.search || ""}${locationLike?.hash || ""}`;
  return new URL(href, "https://optimus.local");
}

function safeSegment(value, fallback) {
  return SAFE_SEGMENT.test(value || "") ? value : fallback;
}

export function readCommandCenterRoute(
  locationLike,
  { allowedDestinations = COMMAND_CENTER_DESTINATIONS } = {},
) {
  const url = asUrl(locationLike);
  const allowed = new Set(allowedDestinations);
  const requestedDestination = safeSegment(
    url.searchParams.get(DESTINATION_PARAM),
    DEFAULT_DESTINATION,
  );
  const destination = allowed.has(requestedDestination)
    ? requestedDestination
    : DEFAULT_DESTINATION;

  return {
    destination,
    view: safeSegment(url.searchParams.get(VIEW_PARAM), DEFAULT_VIEW),
  };
}

export function createCommandCenterUrl(locationLike, route) {
  const url = asUrl(locationLike);
  const destination = safeSegment(route?.destination, DEFAULT_DESTINATION);
  const view = safeSegment(route?.view, DEFAULT_VIEW);

  url.searchParams.set(DESTINATION_PARAM, destination);
  if (view === DEFAULT_VIEW) url.searchParams.delete(VIEW_PARAM);
  else url.searchParams.set(VIEW_PARAM, view);

  return `${url.pathname}${url.search}${url.hash}`;
}

export function writeCommandCenterRoute(
  route,
  { historyApi = window.history, locationLike = window.location, replace = false } = {},
) {
  const nextUrl = createCommandCenterUrl(locationLike, route);
  const currentUrl = createCommandCenterUrl(locationLike, readCommandCenterRoute(locationLike));
  if (nextUrl === currentUrl) return false;
  historyApi[replace ? "replaceState" : "pushState"]({}, "", nextUrl);
  return true;
}
